//--webブラウザ表示向けにProvider設定を定義--//
import wrapWithProvider from "./src/redux/provider"
export const wrapRootElement = wrapWithProvider